import * as React from 'react';
import classNames from 'classnames';
import './splitMethodForm.module.scss';
import { observer } from 'mobx-react';
import { RadioButton } from '../../application/components/RadioButton';
import { SplitCount, SplitMethodFormState } from './states/CardPaymentState';

type OptionProps = {
  selected: boolean;
  splitCount: SplitCount;
  label: string;
  primary: boolean;
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  priceLabel?: any;
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  onSelect: (splitCount: SplitCount) => any;
};

const SplitOption = ({ splitCount, selected, label, priceLabel, onSelect, primary }: OptionProps) => {
  return (
    <div styleName={classNames('option', { primary: primary })} onClick={() => onSelect(splitCount)}>
      <div styleName="radio">
        <RadioButton
          checked={selected}
          onCheck={(checked) => {
            if (checked) {
              onSelect(splitCount);
            }
          }}
        />
      </div>
      <div styleName="body">
        <div styleName="title">{label}</div>
        {priceLabel && <div styleName="price">{priceLabel}</div>}
      </div>
    </div>
  );
};

type PaymentLabelProps = {
  splitCount: SplitCount;
  monthlyPaymentWithTax: number;
};

const MonthlyPaymentLabel = ({ splitCount, monthlyPaymentWithTax }: PaymentLabelProps) => {
  return (
    <div styleName="monthly-payment-label">
      <span styleName="price-highlight">{monthlyPaymentWithTax.toLocaleString()}</span>
      <span styleName="price-unit">円(税込)</span>
      <span styleName="price-duration">/1month × {splitCount}</span>
    </div>
  );
};

type Props = {
  state: SplitMethodFormState;
  priceWithoutTax: number;
};

export const SplitMethodForm = observer(
  class SplitMethodForm extends React.Component<Props> {
    render() {
      const { state, priceWithoutTax } = this.props;
      const { splitCount } = state;
      return (
        <div styleName="split-method-form">
          <div styleName="single">
            <SplitOption
              selected={splitCount === 1}
              splitCount={1}
              label={'一括払い'}
              primary={true}
              onSelect={(sc) => (state.splitCount = sc)}
            />
          </div>
          <div styleName="split">
            {state
              .getSplitOptions()
              .filter((option) => option.splitCount > 1)
              .map((option) => {
                return (
                  <SplitOption
                    key={option.splitCount}
                    selected={splitCount === option.splitCount}
                    splitCount={option.splitCount}
                    label={option.label}
                    primary={option.primary}
                    priceLabel={
                      priceWithoutTax && (
                        <MonthlyPaymentLabel
                          splitCount={option.splitCount}
                          monthlyPaymentWithTax={state.computeMonthlyPaymentWithTax(priceWithoutTax, option.splitCount)}
                        />
                      )
                    }
                    onSelect={(sc) => (state.splitCount = sc)}
                  />
                );
              })}
          </div>
        </div>
      );
    }
  }
);
